<nk-card class="h-100" andClass="h-100 mb-0" [attr.data-cy]="'company-analysis-fraud-risk-card'">
  <nk-card-header [title]="'fraud_risk_score.title' | translate">
    <nk-fraud-risk-score-help-info class="ms-2"></nk-fraud-risk-score-help-info>
  </nk-card-header>
  <nk-card-content andClass="m-0 p-0">
    <nk-company-analysis-fraud-risk-score
      [companyIdentifier]="companyIdentifier()"
      [printVersion]="printVersion()"></nk-company-analysis-fraud-risk-score>
  </nk-card-content>
</nk-card>
